<script>
  import { navigate } from "svelte-navigator";
import Glitch from "../Glitch.svelte";

</script>

<main>
  <Glitch text="ACAPELLA"></Glitch>
  <small> Please use a headset for the best experience. </small>
  <ion-button on:click={() => navigate("/grid")} color="dark">
    UNDERSTOOD
    <ion-icon name="arrow-forward-outline" />
  </ion-button>
</main>

<style>
  main {
    height: 100vh;
    display: flex;
    flex-flow: column;
    justify-content: center;
    align-items: center;
  }

  ion-button {
    margin-top: 20vh;
  }

</style>
